import { useContext } from "react";
import NotificationServices from "../services/notificationServices";
import { AuthContext } from "../contexts/AuthContext";

export default function useNotification() {
  const { api } = useContext(AuthContext);
  const service = new NotificationServices(api);

  const createNotification = async (data) => {
    return service.create(data);
  };

  const getNotifications = async () => {
    return service.getAll();
  };

  const getNotification = async (id) => {
    return service.getOne(id);
  };

  const updateNotification = async (id, data) => {
    return service.update(id, data);
  };

  const deleteNotification = async (id) => {
    return service.delete(id);
  };

  const deleteAllNotifications = async () => {
    return service.deleteAll();
  };

  const readNotification = async (id) => {
    return service.readOne(id);
  };

  const readAllNotifications = async (userId) => {
    return service.readAll(userId);
  };

  return {
    createNotification,
    getNotifications,
    getNotification,
    updateNotification,
    deleteNotification,
    deleteAllNotifications,
    readNotification,
    readAllNotifications,
  };
}
